import { AccountCircleOutlined, EmailOutlined } from "@mui/icons-material";

import { Stack } from "@mui/material";
import { ChangeEmailForm } from "../forms/ChangeEmailForm";
import { PersonalInformationForm } from "../forms/PersonalInformationForm";
import { SettingsCard } from "../layout/SettingsCard";

const AccountSettings = () => {
    return (
        <Stack spacing={2}>
            <SettingsCard
                title="Personal Information"
                icon={AccountCircleOutlined}
            >
                <PersonalInformationForm />
            </SettingsCard>
            <SettingsCard title="Change Email" icon={EmailOutlined}>
                <ChangeEmailForm />
            </SettingsCard>
        </Stack>
    );
};

export default AccountSettings;
